import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ArchiveRecordLabel from 'archive/components/ArchiveRecordLabel';
import StudyDescriptionEditor from 'studies/workspace/StudyDescriptionEditor';
import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import * as Colors from 'ui-library/Colors';

import {StudyOverviewTabContentsProps} from '../utils/TypedStudyTypes';

interface StudyHeaderProps extends StudyOverviewTabContentsProps {
  headerButtons?: {buttonsStyling: React.CSSProperties; buttons: JSX.Element};
  headerBreadcrumb?: JSX.Element;
  headerTabs?: JSX.Element;
  executionContainerStyling?: React.CSSProperties;
  headerSectionContainerStyling?: React.CSSProperties;
  title?: string;
  procedureRunId?: string;
  dataTestAttrs?: DataTestAttrs;
}

export default function StudyExecution(props: StudyHeaderProps): JSX.Element {
  return (
    <div className={css(styles.studyExecutionContainer)} {...getTestProps(props.dataTestAttrs)}>
      <div className={css(styles.headerSectionContainer)}>
        <div style={props.headerSectionContainerStyling}>
          <div className={css(styles.headerSection)}>
            {props.headerBreadcrumb && (
              <div className={css(styles.breadcrumbs)}>{props.headerBreadcrumb}</div>
            )}
            <div className={css(styles.headerTitleAndButtons)}>
              <div className={css(styles.title)}>{props.title ?? props.study.name}</div>
              <div
                className={props.headerButtons ? undefined : css(styles.headerButtons)}
                style={props.headerButtons?.buttonsStyling}
              >
                {props.headerButtons?.buttons}
              </div>
            </div>
            <ArchiveRecordLabel
              item={{name: props.study.name, id: props.study.id, archiveRecord: props.study.archiveRecord}}
            />
            {!props.procedureRunId && (
              <div className={css(styles.description)}>
                <StudyDescriptionEditor
                  study={props.study}
                  refetch={props.refetch}
                  isWritable={props.isEditable}
                />
              </div>
            )}
            {props.headerTabs}
          </div>
        </div>
      </div>
      <div className={css(styles.execution)} style={props.executionContainerStyling}>
        {props.execution}
      </div>
    </div>
  );
}

const styles = StyleSheet.create({
  breadcrumbs: {
    marginBottom: 8,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  headerTitleAndButtons: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  studyExecutionContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    paddingTop: 12,
  },
  title: {
    fontSize: '26px',
    lineHeight: '26px',
    fontWeight: 'bolder',
    display: 'inline-block',
  },
  headerButtons: {
    flex: 'none',
    display: 'flex',
    marginLeft: 'auto',
    padding: 20,
    marginRight: '40px',
    gap: 18,
  },
  headerSectionContainer: {
    borderBottom: `1.5px solid ${Colors.GRAY_LIGHT}`,
  },
  headerSection: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: Colors.WHITE,
    flex: '0 0 auto',
  },
  description: {
    marginBottom: 12,
  },
  execution: {
    backgroundColor: Color.GRAY_100,
    height: '100%',
    maxHeight: '100%',
  },
});
